<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <!-- Page Wrapper -->
    <div class="page-wrapper" ref="formContainer">
      <div class="content container-fluid">
        <!-- Loading Skeleton -->
        <div v-if="loading" class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="text-center">
                  <i class="fas fa-spinner fa-spin fa-3x text-primary"></i>
                  <p class="mt-3">Loading visitor details...</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Actual Content -->
        <div v-else class="row">
          <div class="col-lg-12 mb-3">
            <div class="">
              <div class="card">
                <div class="card-header">
                  <h5
                    class="card-title d-flex justify-content-between align-items-center"
                  >
                    <div v-if="visit">
                      <a
                        @click="goBack"
                        style="cursor: pointer; text-decoration: none; color: inherit;"
                      >
                        <i class="fas fa-arrow-left mr-2"></i>
                      </a>
                      <span
                        >Visitor Details
                        <small
                          v-if="visit.status === 'ACTIVE'"
                          class="badge badge-success ml-2"
                          style="font-size: 12px"
                          >{{ visit.status }}</small
                        >
                        <small
                          v-else-if="visit.status === 'BOOKED'"
                          class="badge badge-success ml-2"
                          style="font-size: 12px"
                          >{{ visit.status }}</small
                        >
                        <small
                          v-else-if="visit.status === 'EXPIRED'"
                          class="badge badge-danger ml-2"
                          style="font-size: 12px"
                          >{{ visit.status }}</small
                        >
                        <small
                          v-else-if="visit.status === 'CANCELLED'"
                          class="badge badge-secondary ml-2"
                          style="font-size: 12px"
                          >{{ visit.status }}</small
                        >
                        <small
                          v-else-if="visit.status === 'CHECKED_IN'"
                          class="badge badge-info ml-2"
                          style="font-size: 12px"
                          >{{ visit.status }}</small
                        >
                        <small
                          v-else-if="visit.status === 'CHECKED_OUT'"
                          class="badge badge-primary ml-2"
                          style="font-size: 12px"
                          >{{ visit.status }}</small
                        >
                        <small
                          v-else
                          class="badge badge-secondary ml-2"
                          style="font-size: 12px"
                          >{{ visit.status }}</small
                        >
                      </span>
                    </div>
                    <div
                      v-if="
                        visit &&
                          (visit.status === 'ACTIVE' ||
                            visit.status === 'BOOKED' ||
                            visit.status === 'CHECKED_IN')
                      "
                    >
                      <button
                        type="button"
                        v-if="visit.status === 'CHECKED_IN'"
                        @click="checkOutVisit(visitId)"
                        class="btn btn-sm bg-primary text-white mr-2"
                      >
                        <i class="fas fa-sign-out-alt"></i> Check Out
                      </button>

                      <button
                        class="btn btn-sm bg-warning"
                        type="button"
                        @click="cancelVisit(visitId)"
                      >
                        <i class="fas fa-times-circle"></i> Cancel
                      </button>
                    </div>
                  </h5>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div v-if="visit && visit.accessCode" class="col-md-6 mb-3">
                      <div class="visit-info-item">
                        <div
                          class="visit-info-label"
                          style="color: #637381; font-size: 12px; font-weight: 600; text-transform: uppercase; margin-bottom: 5px;"
                        >
                          Access Code
                        </div>
                        <div
                          class="visit-info-value"
                          style="font-size: 24px; font-weight: 700; letter-spacing: 4px; color: #0d6efd;"
                        >
                          {{ visit.accessCode }}
                        </div>
                      </div>
                    </div>

                    <div v-if="visit && visit.code" class="col-md-6 mb-3">
                      <div class="visit-info-item">
                        <div
                          class="visit-info-label"
                          style="color: #637381; font-size: 12px; font-weight: 600; text-transform: uppercase; margin-bottom: 5px;"
                        >
                          Reference
                        </div>
                        <div
                          class="visit-info-value"
                          style="font-size: 14px; font-weight: 500;"
                        >
                          {{ visit.code }}
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="visit && visit.bookingType"
                      class="col-md-6 mb-3"
                    >
                      <div class="visit-info-item">
                        <div
                          class="visit-info-label"
                          style="color: #637381; font-size: 12px; font-weight: 600; text-transform: uppercase; margin-bottom: 5px;"
                        >
                          Visitor Type
                        </div>
                        <div
                          class="visit-info-value"
                          style="font-size: 14px; font-weight: 500;"
                        >
                          {{
                            visit.bookingType === "CONTRACTOR"
                              ? "SERVICE PROVIDER"
                              : visit.bookingType
                          }}
                        </div>
                      </div>
                    </div>

                    <div v-if="visit && getVisitorName()" class="col-md-6 mb-3">
                      <div class="visit-info-item">
                        <div
                          class="visit-info-label"
                          style="color: #637381; font-size: 12px; font-weight: 600; text-transform: uppercase; margin-bottom: 5px;"
                        >
                          Visitor Name
                        </div>
                        <div
                          class="visit-info-value"
                          style="font-size: 14px; font-weight: 500;"
                        >
                          {{ getVisitorName() }}
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="visit && visit.visitor && visit.visitor.email"
                      class="col-md-6 mb-3"
                    >
                      <div class="visit-info-item">
                        <div
                          class="visit-info-label"
                          style="color: #637381; font-size: 12px; font-weight: 600; text-transform: uppercase; margin-bottom: 5px;"
                        >
                          Email
                        </div>
                        <div
                          class="visit-info-value"
                          style="font-size: 14px; font-weight: 500;"
                        >
                          {{ visit.visitor.email }}
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="visit && visit.visitor && visit.visitor.phone"
                      class="col-md-6 mb-3"
                    >
                      <div class="visit-info-item">
                        <div
                          class="visit-info-label"
                          style="color: #637381; font-size: 12px; font-weight: 600; text-transform: uppercase; margin-bottom: 5px;"
                        >
                          Phone
                        </div>
                        <div
                          class="visit-info-value"
                          style="font-size: 14px; font-weight: 500;"
                        >
                          {{ visit.visitor.phone }}
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="visit && visit.visitor && visit.visitor.name"
                      class="col-md-6 mb-3"
                    >
                      <div class="visit-info-item">
                        <div
                          class="visit-info-label"
                          style="color: #637381; font-size: 12px; font-weight: 600; text-transform: uppercase; margin-bottom: 5px;"
                        >
                          Company
                        </div>
                        <div
                          class="visit-info-value"
                          style="font-size: 14px; font-weight: 500;"
                        >
                          {{ visit.visitor.name }}
                        </div>
                      </div>
                    </div>

                    <div v-if="visit" class="col-md-6 mb-3">
                      <div class="visit-info-item">
                        <div
                          class="visit-info-label"
                          style="color: #637381; font-size: 12px; font-weight: 600; text-transform: uppercase; margin-bottom: 5px;"
                        >
                          Number of People
                        </div>
                        <div
                          class="visit-info-value"
                          style="font-size: 14px; font-weight: 500;"
                        >
                          {{ visit.numberOfPeople || "-" }}
                        </div>
                      </div>
                    </div>

                    <div v-if="visit" class="col-md-6 mb-3">
                      <div class="visit-info-item">
                        <div
                          class="visit-info-label"
                          style="color: #637381; font-size: 12px; font-weight: 600; text-transform: uppercase; margin-bottom: 5px;"
                        >
                          Entries
                        </div>
                        <div
                          class="visit-info-value"
                          style="font-size: 14px; font-weight: 500;"
                        >
                          {{ visit.entriesUsed || 0 }} /
                          {{ visit.numberOfEntries || "∞" }}
                        </div>
                      </div>
                    </div>

                    <div v-if="visit" class="col-md-6 mb-3">
                      <div class="visit-info-item">
                        <div
                          class="visit-info-label"
                          style="color: #637381; font-size: 12px; font-weight: 600; text-transform: uppercase; margin-bottom: 5px;"
                        >
                          Vehicle Registration
                        </div>
                        <div
                          class="visit-info-value"
                          style="font-size: 14px; font-weight: 500;"
                        >
                          {{ visit.vehicleRegistration || "-" }}
                        </div>
                      </div>
                    </div>

                    <div v-if="visit && visit.startDate" class="col-md-6 mb-3">
                      <div class="visit-info-item">
                        <div
                          class="visit-info-label"
                          style="color: #637381; font-size: 12px; font-weight: 600; text-transform: uppercase; margin-bottom: 5px;"
                        >
                          Start Date
                        </div>
                        <div
                          class="visit-info-value"
                          style="font-size: 14px; font-weight: 500;"
                        >
                          {{
                            convertToLocalDate(
                              visit.startDate,
                              visit.startTime
                            )
                          }},
                          {{
                            convertToLocalTime(visit.startDate, visit.startTime)
                          }}
                        </div>
                      </div>
                    </div>

                    <div v-if="visit && visit.endDate" class="col-md-6 mb-3">
                      <div class="visit-info-item">
                        <div
                          class="visit-info-label"
                          style="color: #637381; font-size: 12px; font-weight: 600; text-transform: uppercase; margin-bottom: 5px;"
                        >
                          End Date
                        </div>
                        <div
                          class="visit-info-value"
                          style="font-size: 14px; font-weight: 500;"
                        >
                          {{
                            convertToLocalDate(visit.endDate, visit.endTime)
                          }},
                          {{ convertToLocalTime(visit.endDate, visit.endTime) }}
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="visit && visit.isFrequentVisitor !== undefined"
                      class="col-md-6 mb-3"
                    >
                      <div class="visit-info-item">
                        <div
                          class="visit-info-label"
                          style="color: #637381; font-size: 12px; font-weight: 600; text-transform: uppercase; margin-bottom: 5px;"
                        >
                          Frequent Visitor
                        </div>
                        <div
                          class="visit-info-value"
                          style="font-size: 14px; font-weight: 500;"
                        >
                          <span
                            v-if="visit.isFrequentVisitor"
                            class="badge bg-success"
                            >Yes</span
                          >
                          <span v-else class="badge bg-secondary">No</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
  <!-- /Main Wrapper -->
</template>

<script>
import visitService from "../../service/appointment.service";
import { convertToLocalDate, convertToLocalTime } from "../../utils/utils";

export default {
  name: "view-visit",
  data() {
    return {
      visitId: null,
      visit: null,
      loading: true
    };
  },
  methods: {
    retrieveVisit(id) {
      this.loading = true;
      const contextId =
        localStorage.getItem("contextId") ||
        localStorage.getItem("selectedContextId");

      if (!contextId) {
        this.fireNotification("error", "Error", "Customer context not found");
        this.$router.push("/visits");
        return;
      }

      visitService
        .findById(contextId, id)
        .then(response => {
          if (response.data.code === "SUCCESS") {
            this.visit = response.data.data;
            this.visitId = this.visit.id;
          } else {
            this.fireNotification(
              "error",
              "Error",
              response.data.narrative || "Failed to load visitor"
            );
            this.$router.push("/visits");
          }
        })
        .catch(e => {
          console.log(e);
          if (
            e.response &&
            (e.response.status === 401 ||
              e.response.status === 403 ||
              e.response.status === 409)
          ) {
            return;
          }
          this.fireNotification(
            "error",
            "Error",
            "Failed to load visitor details"
          );
          this.$router.push("/visits");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    checkInVisit(id) {
      const contextId =
        localStorage.getItem("contextId") ||
        localStorage.getItem("selectedContextId");

      Swal.fire({
        title: "Check In",
        text: "Mark this visitor as checked in?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Yes, check in"
      }).then(result => {
        if (result.isConfirmed) {
          visitService
            .checkIn(contextId, id)
            .then(response => {
              if (response.data.code === "SUCCESS") {
                this.visit = response.data.data;
                this.fireNotification(
                  "success",
                  "Success",
                  "Visitor checked in successfully"
                );
              } else {
                this.fireNotification(
                  "error",
                  "Error",
                  response.data.narrative || "Failed to check in"
                );
              }
            })
            .catch(e => {
              console.log(e);
              if (
                e.response &&
                (e.response.status === 401 ||
                  e.response.status === 403 ||
                  e.response.status === 409)
              ) {
                return;
              }
              this.fireNotification(
                "error",
                "Error",
                "Failed to check in visitor"
              );
            });
        }
      });
    },

    checkOutVisit(id) {
      const contextId =
        localStorage.getItem("contextId") ||
        localStorage.getItem("selectedContextId");

      Swal.fire({
        title: "Check Out",
        text: "Mark this visitor as checked out?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#007bff",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Yes, check out"
      }).then(result => {
        if (result.isConfirmed) {
          visitService
            .checkOut(contextId, id)
            .then(response => {
              if (response.data.code === "SUCCESS") {
                this.visit = response.data.data;
                this.fireNotification(
                  "success",
                  "Success",
                  "Visitor checked out successfully"
                );
              } else {
                this.fireNotification(
                  "error",
                  "Error",
                  response.data.narrative || "Failed to check out"
                );
              }
            })
            .catch(e => {
              console.log(e);
              if (
                e.response &&
                (e.response.status === 401 ||
                  e.response.status === 403 ||
                  e.response.status === 409)
              ) {
                return;
              }
              this.fireNotification(
                "error",
                "Error",
                "Failed to check out visitor"
              );
            });
        }
      });
    },

    cancelVisit(visitId) {
      const contextId =
        localStorage.getItem("contextId") ||
        localStorage.getItem("selectedContextId");

      Swal.fire({
        title: "Are you sure?",
        text: "This will cancel the visitor!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ffc107",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Yes, cancel it"
      }).then(result => {
        if (result.isConfirmed) {
          visitService
            .cancel(contextId, visitId)
            .then(response => {
              if (response.data.code === "SUCCESS") {
                this.visit = response.data.data;
                this.fireNotification(
                  "success",
                  "Cancelled",
                  "Visitor cancelled successfully"
                );
              } else {
                this.fireNotification(
                  "error",
                  "Error",
                  response.data.narrative || "Failed to cancel visitor"
                );
              }
            })
            .catch(e => {
              console.log(e);
              if (
                e.response &&
                (e.response.status === 401 ||
                  e.response.status === 403 ||
                  e.response.status === 409)
              ) {
                return;
              }
              this.fireNotification(
                "error",
                "Error",
                "Failed to cancel visitor"
              );
            });
        }
      });
    },

    deleteVisit(visitId) {
      const contextId =
        localStorage.getItem("contextId") ||
        localStorage.getItem("selectedContextId");

      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.isConfirmed) {
          visitService
            .delete(contextId, visitId)
            .then(response => {
              if (response.data.code === "SUCCESS") {
                this.fireNotification(
                  "success",
                  "Deleted",
                  "Visitor deleted successfully"
                );
                this.$router.push("/visits");
              } else {
                this.fireNotification(
                  "error",
                  "Error",
                  response.data.narrative || "Failed to delete visitor"
                );
              }
            })
            .catch(e => {
              console.log(e);
              if (
                e.response &&
                (e.response.status === 401 ||
                  e.response.status === 403 ||
                  e.response.status === 409)
              ) {
                return;
              }
              this.fireNotification(
                "error",
                "Error",
                "Failed to delete visitor"
              );
            });
        }
      });
    },

    getVisitorName() {
      if (!this.visit) return "";

      // For CONTRACTOR and DELIVERY bookings, use the name field directly
      if (
        (this.visit.bookingType === "CONTRACTOR" ||
          this.visit.bookingType === "DELIVERY") &&
        this.visit.name
      ) {
        return this.visit.name;
      }

      // For GUEST bookings, try to get name from visitor object
      if (this.visit.visitor) {
        if (this.visit.visitor.name) {
          return this.visit.visitor.name;
        }
        if (this.visit.visitor.firstName || this.visit.visitor.lastName) {
          return `${this.visit.visitor.firstName || ""} ${this.visit.visitor
            .lastName || ""}`.trim();
        }
      }

      // Fallback to old structure
      if (this.visit.firstName || this.visit.lastName) {
        return `${this.visit.firstName || ""} ${this.visit.lastName ||
          ""}`.trim();
      }

      return "-";
    },

    convertToLocalDate(utcDate, utcTime) {
      return convertToLocalDate(utcDate, utcTime);
    },

    convertToLocalTime(utcDate, utcTime) {
      return convertToLocalTime(utcDate, utcTime);
    },

    goBack() {
      this.$router.push("/visits");
    },

    fireNotification(icon, title, message) {
      Swal.fire({
        icon: icon,
        title: title,
        text: message,
        footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    this.visitId = this.$route.params.id;

    if (!this.currentUser) {
      this.$router.push("/login");
      return;
    }

    if (!this.visitId) {
      this.fireNotification("error", "Error", "Visitor ID not found");
      this.$router.push("/visits");
      return;
    }

    this.retrieveVisit(this.visitId);
  }
};
</script>

<style scoped>
.visit-info-item {
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 5px;
  height: 100%;
}

.btn-block {
  width: 100%;
}

.badge {
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 600;
}

.bg-success-light {
  background-color: #28a745 !important;
}

.bg-danger-light {
  background-color: #dc3545 !important;
}

.bg-info-light {
  background-color: #17a2b8 !important;
}

.bg-primary-light {
  background-color: #007bff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/visit/ViewVisitV2.vue